import { Injectable } from '@angular/core';
import { FooterLink, FooterResponse } from './footer.viewmodel';
import { map, Observable, of } from 'rxjs';
import { FooterData, FooterModel } from './footer.model';
import { PageService } from '../common/services/page/page.service';
import { CACHE_KEYS } from '../common/constants/cache-keys';
import { ExperienceFragmentRequest } from '../common/services/page/page-component-data.viewmodel';
import { LoginResults, LoginSelections } from '../login/login.viewmodel';
import { BaseService } from '../common/services/base.service';
import { CacheService } from '../common/services/cache.service';
import { SettingsService } from '../common/services/settings.service';
import { getUrlByCategory } from '../common/util/utils';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  constructor(private pageService: PageService, private settingsService: SettingsService, private baseService: BaseService, private cacheService: CacheService) {}

  getFooter(): Observable<FooterData> {
    let url: string = `/v1/lpmi/portal/getFooter`;
    let loginSelections: LoginSelections = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_SELECTIONS);
    let region = loginSelections?.region;
    let businessOp = loginSelections?.selectedBusinessLabel.key;
    let businessUnit = businessOp === 'HQ/Admin' || businessOp === 'admin' ? 'admin' : businessOp;
    let countryCode = loginSelections?.market;
    let language = this.pageService.getPreferredLanguage().languageCode;
    let request = new ExperienceFragmentRequest();
    request.componentType = '';
    request.userDetails = this.pageService.getUserDetails();
    request.experienceFragments = [ `${this.settingsService.NUC_PAGE_PATH_PREFIX}/${region}/${countryCode}/${language}/${businessUnit}/footer`
    ];
    return this.baseService.post<FooterResponse>(`${url}`, request, 'API').pipe(
      // return this.getFooterMocked().pipe(
      map((response: FooterResponse) => {
        const footerComponentResults: FooterLink[] = response?.results?.footer?.links;
        const links: FooterModel[] = footerComponentResults?.map(this.getFooterItem);
        const footerData = new FooterData();
        footerData.cqPath = response?.results?.footer?.cqPath;
        footerData.links = links;
        footerData.labels = response?.results?.labels;
        return footerData;
      })
    );
  }

  private getFooterItem(fl: FooterLink) {
    let link: string;
    let type: string;
    if (fl.type != 'docLink' && fl.category != 'external') {
      if (fl.category) {
        fl.link = getUrlByCategory(fl.category);
      }
    }
    if (fl.type == 'docLink') {
      link = fl.document;
    }else {
      link = fl.link;
    }
    //  else {
    //   if (fl.category) {
    //     link = getUrlByCategory(fl.category);
    //   }else {
    //     link = fl.link;
    //   }
    return new FooterModel({
      name: fl.label,
      link: link,
      label: fl.label,
      cqPath: fl.cqPath,
      type: type || fl.linkType,
      navigationType: fl.type,
      document: fl.document,
      category: fl.category
    });
  }
}
